const searchPlaceHolder: any = {
  users: "Search",
  roles: "Search",
  "service-provider": "Search",
  resellers: "Search",
  designations: "Search",
  industries: "Search",
  "job-types": "Search",
  skill: "Search",
  services: "Search",
  qualifications: "Search",
  skills: "Search",
};
export default searchPlaceHolder;
